export const QA_NAME_BUILDING_GROUP_CREATION_MODAL = 'buildingGroup'
